export default "__VITE_ASSET__C5FUr$Ol__"